import LeanBar from '@/components/ui/LeanBar'

// The coverage block (Sam, 2026-11-01): how a PAGE shows its own lean, at
// the top of a story, a storyline and a topic. Each side's count as a big
// number over its own segment of the 12px bar (the columns are sized by the
// counts), then one line: "733 articles · Pano rates the coverage
// Balanced", and an optional note under it. List rows use the other pattern
// (LeanMark).
//
// `articles` is what opens the line: a number, or a node such as the story
// page's link that opens its articles panel. `info` follows the verdict
// (the story page's ⓘ explainer).

const SIDES = [
  { key: 'left', word: 'Left', text: 'text-blue-600 dark:text-blue-400' },
  { key: 'center', word: 'Center', text: 'text-muted-foreground' },
  { key: 'right', word: 'Right', text: 'text-red-600 dark:text-red-400' },
]

export default function CoverageBlock({
  counts,
  articles,
  label,
  info = null,
  note = null,
  className = '',
}) {
  const lean = {
    left: counts?.left || 0,
    center: counts?.center || 0,
    right: counts?.right || 0,
  }
  const total = lean.left + lean.center + lean.right
  if (!total) return null
  const shown = SIDES.filter(({ key }) => lean[key] > 0)
  const opener =
    articles ??
    `${total.toLocaleString()} ${total === 1 ? 'article' : 'articles'}`

  return (
    <section aria-label="Coverage" className={className}>
      <div
        className="grid items-end gap-x-2"
        style={{
          gridTemplateColumns: shown
            .map(({ key }) => `minmax(3.5rem, ${lean[key]}fr)`)
            .join(' '),
        }}
        aria-hidden="true"
      >
        {shown.map(({ key, word, text }) => (
          <div key={key} className={text}>
            <p className="font-serif text-[30px] leading-none tabular-nums sm:text-5xl">
              {lean[key].toLocaleString()}
            </p>
            <p className="mb-2 mt-1 font-sans text-[11px] font-semibold uppercase tracking-[0.12em] sm:text-xs">
              {word}
            </p>
          </div>
        ))}
      </div>
      <LeanBar counts={lean} size="list" className="w-full sm:h-3" />
      <p className="mt-2 font-sans text-xs text-muted-foreground sm:text-[13px]">
        <span className="tabular-nums">{opener}</span>
        {label && (
          <>
            {' · '}Pano rates the coverage{' '}
            <span className="font-semibold text-foreground">{label}</span>
            {info}
          </>
        )}
      </p>
      {note && (
        <p className="mt-1 font-sans text-xs text-muted-foreground sm:text-[13px]">
          {note}
        </p>
      )}
    </section>
  )
}
